// Mobile filter + sort bridge — mobile only.
//
// FILTER: the visible gold filter button is the theme's native .facet-wrapper.
// Cloud Search renders its own button into #cloud_search_filters_root which is
// hidden by CSS. We forward taps from the gold button to Cloud Search.
//
// SORT: the theme's native facet-sort has a JS open/close state that misbehaves
// in narrow viewports. We hide it on mobile and inject a custom .mobile-sort-wrapper
// that uses a native <select> — the OS picker is reliable and matches mobile UX.

(function () {
  // Desktop — exit immediately, nothing to do
  if (window.matchMedia('(min-width: 768px)').matches) return;

  var CLOUD_SELECTOR =
    '#cloud_search_filters_root .cloud-search-page-controls__filters-link, ' +
    '#cloud_search_filters_root button';
  var NATIVE_SELECTOR =
    '.facet-topbar > .facet-wrapper button, ' +
    '.facet-topbar > .facet-wrapper [is="hover-button"]';

  var cloudBtn = null;
  var observer = null;

  function cacheCloudBtn() {
    cloudBtn = document.querySelector(CLOUD_SELECTOR);
    if (cloudBtn && observer) {
      observer.disconnect();
      observer = null;
    }
    return cloudBtn;
  }

  function shortenButtonText() {
    // On mobile only, change "Show filters" → "Filters" in the topbar button.
    document.querySelectorAll('.facet-topbar .facet-wrapper button, .facet-topbar .facet-wrapper [is="hover-button"]').forEach(function (btn) {
      var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (/Show filters/i.test(node.textContent)) {
          node.textContent = node.textContent.replace(/Show filters/gi, 'Filters');
        }
      }
    });
  }

  function buildMobileSort() {
    var sortContainer = document.getElementById('SortByContainer');
    if (!sortContainer) return;
    // Idempotent — don't double-inject
    var topbar = sortContainer.parentNode;
    if (!topbar || topbar.querySelector('.mobile-sort-wrapper')) return;

    // Read options from the theme's existing radio inputs so merchant config wins
    var radios = sortContainer.querySelectorAll('input[type="radio"][name="sort_by"]');
    if (!radios.length) return;

    var optionMap = {};  // value → { label, radio }
    var currentLabel = '';

    var wrapper = document.createElement('div');
    wrapper.className = 'mobile-sort-wrapper';

    var select = document.createElement('select');
    select.className = 'mobile-sort-select';
    select.setAttribute('aria-label', 'Sort products');

    radios.forEach(function (radio) {
      var label = sortContainer.querySelector('label[for="' + radio.id + '"]');
      var labelText = label ? label.textContent.trim() : radio.value;
      optionMap[radio.value] = { label: labelText, radio: radio };

      var optionEl = document.createElement('option');
      optionEl.value = radio.value;
      optionEl.textContent = labelText;
      if (radio.checked) {
        optionEl.selected = true;
        currentLabel = labelText;
      }
      select.appendChild(optionEl);
    });

    // On select change: trigger the matching theme radio so the theme's
    // existing AJAX sort flow handles the update — no page reload.
    // Also swap the button label from "Sort by" to the selected option's name.
    select.addEventListener('change', function (e) {
      var entry = optionMap[e.target.value];
      if (!entry) return;

      // Update visible label to the selected option's name
      var labelEl = wrapper.querySelector('.mobile-sort-label');
      if (labelEl) labelEl.textContent = entry.label;

      // Sync the theme's radio and dispatch the event the theme listens for.
      // Some themes hook 'change'; some hook 'click' — fire both to be safe.
      entry.radio.checked = true;
      entry.radio.dispatchEvent(new Event('change', { bubbles: true }));
      entry.radio.dispatchEvent(new Event('click', { bubbles: true }));
    });

    var content = document.createElement('span');
    content.className = 'mobile-sort-content';
    content.innerHTML =
      '<span class="mobile-sort-label">Sort by</span>' +
      '<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';

    wrapper.appendChild(content);
    wrapper.appendChild(select);
    topbar.appendChild(wrapper);
  }

  function init() {
    shortenButtonText();
    buildMobileSort();

    // Tag the topbar so CSS reveals it atomically — prevents the slow-network
    // flash of the theme's native full-width "Show filters" button before our
    // 2-column layout is built. Runs even if buildMobileSort bails early.
    var topbar = document.querySelector('.facet-topbar');
    if (topbar) topbar.classList.add('mobile-ready');

    if (cacheCloudBtn()) return;

    var root = document.getElementById('cloud_search_filters_root');
    if (!root) return;
    observer = new MutationObserver(cacheCloudBtn);
    observer.observe(root, { childList: true, subtree: true });
  }

  // Single click delegate, capture phase to intercept before theme's handler
  document.addEventListener('click', function (e) {
    var nativeBtn = e.target.closest(NATIVE_SELECTOR);
    if (!nativeBtn) return;

    if (!cloudBtn || !cloudBtn.isConnected) cacheCloudBtn();

    if (cloudBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      cloudBtn.click();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
